import { useEffect, useState } from "react";
import { hierarchyViewService } from "Services/AdminServices/Organization/HierarchyViewService";

export const useHierarchy = () => {
  const [hierarchy, setHierarchy] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchHierarchy = async () => {
    try {
      setLoading(true);
      const data = await hierarchyViewService.getHierarchy();
      setHierarchy(data);
    } catch (error) {
      console.error("Error fetching hierarchy", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchDirectReports = async (supervisorId) => {
    try {
      const data = await hierarchyViewService.getDirectReports(supervisorId);
      return data;
    } catch (error) {
      console.error("Error fetching Direct Reports", error);
      return [];
    }
  };

  useEffect(() => {
    fetchHierarchy();
  }, []);

  return {
    hierarchy,
    loading,
    fetchDirectReports,
  };
};